import apiUsers from '@/api/users'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  user: null,
}

export const mutationTypes = {
  updateUserStart: '[update user] Update user start',
  updateUserSuccess: '[update user] Update user success',
  updateUserFailure: '[update user] Update user failure',

  getUserStart: '[update user] Get user start',
  getUserSuccess: '[update user] Get user success',
  getUserFailure: '[update user] Get user failure',

  resetPasswordStart: '[update user] Reset password user Start',
  resetPasswordSuccess: '[update user] Reset password user Success',
  resetPasswordFailure: '[update user] Reset password user Failure',

  deleteUserStart: '[delete user] delete user start',
  deleteUserSuccess: '[delete user] delete user success',
  deleteUserFailure: '[delete user] delete user failure',
}

export const actionTypes = {
  updateUser: '[update user] Update user',
  getUser: '[update user] Get user',
  resetPassword: '[update user] Reset password user',
  deleteUser: '[delete user] Delete user',
}

const mutations = {
  [mutationTypes.updateUserStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.updateUserSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateUserFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getUserStart](state) {
    state.isLoading = true
    state.user = null
  },

  [mutationTypes.getUserSuccess](state, payload) {
    state.user = payload
    state.isLoading = false
  },

  [mutationTypes.getUserFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.resetPasswordStart](state) {
    state.isSubmitting = true
  },
  [mutationTypes.resetPasswordSuccess](state) {
    state.isSubmitting = false
  },
  [mutationTypes.resetPasswordFailure](state, payload) {
    state.validationErrors = payload
    state.isSubmitting = false
  },

  [mutationTypes.deleteUserStart](state) {
    state.isSubmitting = true
  },
  [mutationTypes.deleteUserSuccess](state) {
    state.isSubmitting = false
  },
  [mutationTypes.deleteUserFailure](state, payload) {
    state.validationErrors = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.updateUser](context, {id, userInput}) {
    context.commit(mutationTypes.updateUserStart)
    return new Promise((resolve) => {
      apiUsers
        .updateUser(id, userInput)
        .then((response) => {
          context.commit(mutationTypes.updateUserSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateUserFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getUser](context, {id}) {
    context.commit(mutationTypes.getUserStart)
    return new Promise((resolve) => {
      apiUsers
        .getUser(id)
        .then((response) => {
          context.commit(mutationTypes.getUserSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getUserFailure)
        })
    })
  },

  [actionTypes.resetPassword](context, {passwords}) {
    context.commit(mutationTypes.resetPasswordStart)
    return new Promise((resolve) => {
      apiUsers
        .resetPasswordUser(passwords)
        .then((user) => {
          context.commit(mutationTypes.resetPasswordSuccess, user)
          resolve(user)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.resetPasswordFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionTypes.deleteUser](context, {id}) {
    context.commit(mutationTypes.deleteUserStart)
    return new Promise((resolve) => {
      apiUsers
        .deleteUser(id)
        .then((response) => {
          context.commit(mutationTypes.deleteUserSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.deleteUserFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
